import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { CancelRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import { StyledButton, StyledDialog } from './index.style';

const WarningRequestDialog = ({
  open,
  onClose,
  onSure,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className="wrap-title">
        <Box className="title">
          <Typography className="text-title">{t(title)}</Typography>
        </Box>
        <CancelRounded sx={{ color: COLOR.darkV2[32] }} onClick={onClose} />
      </DialogTitle>
      <Divider />
      <DialogContent className="wrap-content">
        <Typography className="desc">{t(description)}</Typography>
      </DialogContent>
      <DialogActions className="wrap-actions">
        <StyledButton
          variant="contained"
          onClick={onSure}
          bgrDisble={COLOR.yellow[32]}
          colorDisable="#3c164e99"
        >
          {t('continue')}
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default WarningRequestDialog;
